var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('food',{attrs:{"classfy":_vm.classfy}})}
var staticRenderFns = []

export { render, staticRenderFns }